module.exports = __webpack_public_path__ + "static/mobile-mockup-12d497e8f61bd1fba366ebbae0e13f05.png";